import React from 'react';

import CampaignSummaryPosting from './CampaignSummaryPosting.jsx';
import CampaignDetailsPosting from './CampaignDetailsPosting.jsx';

export default class CampaignInfoPosting extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    render() {
        return (
            <div className="row campaign-info">
                <div className="col-sm-6 col-sm-push-6 col-md-6 col-md-push-6 campaign-summary-container" align="center">
                    <CampaignSummaryPosting
                        selectedCampaignType={this.props.selectedCampaignType}
                        selectedData={this.props.selectedData}
                        selectedDataType={this.props.selectedDataType}
                        onSelectPostingDate={(postingDate) => this.props.onSelectPostingDate(postingDate)}
                        campaignInfo={this.props.campaignInfo}
                        contactsLabel={this.props.contactsLabel}
                        postingPeriods={this.props.postingPeriods}
                        parameters={this.props.parameters}/>
                </div>
                <div className="col-sm-6 col-sm-pull-6 col-md-6 col-md-pull-6">
                        <CampaignDetailsPosting
                            campaignInfo={this.props.campaignInfo}
                            orderData={this.props.orderData}
                            campaignName={this.props.campaignName}
                            periodManuallySelected={this.props.periodManuallySelected}
                            selectedCampaignType={this.props.selectedCampaignType}
                            selectedData={this.props.selectedData}
                            selectedDataType={this.props.selectedDataType}
                            selectedDetailsData={this.props.selectedDetailsData}
                            panels={this.props.panels}
                            parameters={this.props.parameters}
                            allowAddressExport={this.props.allowAddressExport}/>
                </div>
            </div>
        );
    }
}